export default __webpack_public_path__ + "static/media/100YearsOfKokataBranch.3e1494f0.png";